import {
	PASSWORD_FORGOT_REQUEST,
	PASSWORD_FORGOT_FAILURE,
	PASSWORD_FORGOT_SUCCESS,
	PASSWORD_RESET_REQUEST,
	PASSWORD_RESET_FAILURE,
	PASSWORD_RESET_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
	isSending: false,
	message: {
		type: '',
		text: '',
	},
};

export default function password(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case PASSWORD_FORGOT_REQUEST:
			return {
				...state,
				isSending: true,
				message: {
					type: '',
					text: '',
				},
			};

		case PASSWORD_FORGOT_FAILURE:
			return {
				...state,
				isSending: false,
				message: {
					type: 'error',
					text: payload.text,
				},
			};

		case PASSWORD_FORGOT_SUCCESS:
			return {
				...state,
				isSending: false,
				message: {
					type: 'success',
					text: payload.text,
				},
			};

		case PASSWORD_RESET_REQUEST:
			return {
				...state,
				isSending: true,
				message: {
					type: '',
					text: '',
				},
			};

		case PASSWORD_RESET_FAILURE:
			return {
				...state,
				isSending: false,
				message: {
					type: 'error',
					text: payload.text,
				},
			};

		case PASSWORD_RESET_SUCCESS:
			return {
				...state,
				isSending: false,
				message: {
					type: 'success',
					text: payload.text,
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/password.js